// extracted by mini-css-extract-plugin
module.exports = {"emojWrapper":"emojWrapper___2kot-","icon":"icon___2T5v2"};